export const WarningIcon = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100.03" height="80">
          <g>
              <path d="M-1260-300h2500V700h-2500z" fill="#fff"/>
              <path d="M98.7 69.6l-21-32L56.5 4c-3.4-5.28-9.9-5.28-13.2-.24l-21 31.92-21 33.92c-3.4 5.28.3 10.4 7 10.4h83.4c7-.24 10.4-5.36 7-10.4zm-43-46.96l-1.6 28.32h-8l-1.5-28.32h11.1zM50 68.4c-3.9 0-6.5-2.72-6.5-6.08 0-3.6 2.6-6 6.5-6s6.2 2.4 6.5 6c0 3.36-2.6 6.08-6.5 6.08z" stroke="#000" stroke-opacity="0" fill="#0078d7"/>
          </g>
      </svg>
  );
};